/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description modals thunks
 */

import type { MODAL_TYPE } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import { closeModal as closeModalAction, openModal as openModalAction } from '../actions/index'

export const openModal = (modalType: MODAL_TYPE) => (dispatch: Dispatch) => {
  dispatch(openModalAction(modalType))
}

export const closeModal = () => (dispatch: Dispatch) => {
  dispatch(closeModalAction())
}
